import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrialExipedMessageComponent } from './trial-exiped-message.component';

const routes: Routes = [{ path: '', component: TrialExipedMessageComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrialExipedMessageRoutingModule { }
